export default function () {
  if (typeof window !== 'undefined') {
    // Store original Bugsnag notify if it exists
    const originalBugsnagNotify = window.Bugsnag && window.Bugsnag.notify;

    // Override Bugsnag notify to filter out InvalidError events
    if (window.Bugsnag) {
      window.Bugsnag.notify = function(error, ...args) {
        // Check if this is an InvalidError about unhandledrejection handler
        if (error && error.name === 'InvalidError' &&
            error.message && error.message.includes('unhandledrejection handler received a non-error')) {
          // Suppress this specific error from reaching Bugsnag
          console.warn('Suppressing InvalidError from Bugsnag:', error.message);
          return;
        }
        // Otherwise, call the original notify function
        return originalBugsnagNotify.call(this, error, ...args);
      };
    }

    // Handle unhandled promise rejections
    window.addEventListener('unhandledrejection', function(event) {
      // Always prevent the default behavior to stop these from reaching Bugsnag as InvalidErrors
      event.preventDefault();

      // Log for debugging purposes
      console.warn('Unhandled promise rejection intercepted:', {
        reason: event.reason,
        type: typeof event.reason,
        isError: event.reason instanceof Error
      });

      // Only create proper errors for legitimate debugging cases
      if (event.reason instanceof Error) {
        // This is already a proper error, just log it
        console.error('Legitimate error rejection:', event.reason);
      } else {
        // This is a non-error rejection, which we'll handle gracefully
        console.warn('Non-error rejection suppressed:', event.reason);

        // Only log to Bugsnag if it's something we actually want to track
        // Skip common non-error rejections that aren't actionable
        const reasonStr = String(event.reason);
        const commonIgnorablePatterns = [
          'AbortError',
          'Navigation cancelled',
          'Request timed out',
          'Network request failed',
          'User cancelled',
          'Permission denied'
        ];

        const shouldIgnore = commonIgnorablePatterns.some(pattern =>
          reasonStr.includes(pattern)
        );

        if (!shouldIgnore && window.$bugsnag) {
          // Create a proper Error for tracking, but mark it as low severity
          const trackingError = new Error(`Non-error rejection: ${reasonStr}`);
          trackingError.originalReason = event.reason;

          window.$bugsnag.notify(trackingError, (report) => {
            report.severity = 'info'; // Low priority
            report.addMetadata('rejection', 'originalReason', event.reason);
            report.addMetadata('rejection', 'reasonType', typeof event.reason);
            report.addMetadata('rejection', 'suppressed', true);
          });
        }
      }
    });

    // Also handle cases where the nuxt-bugsnag module might be creating these errors
    const originalAddEventListener = window.addEventListener;
    window.addEventListener = function(type, listener, ...args) {
      if (type === 'unhandledrejection' && listener.toString().includes('InvalidError')) {
        // This looks like the nuxt-bugsnag handler, wrap it to prevent InvalidError creation
        const wrappedListener = function(event) {
          // Don't call the original bugsnag handler for non-error rejections
          if (event.reason instanceof Error) {
            return listener.call(this, event);
          }
          // For non-errors, just prevent default and return
          event.preventDefault();
        };
        return originalAddEventListener.call(this, type, wrappedListener, ...args);
      }
      return originalAddEventListener.call(this, type, listener, ...args);
    };
  }
}